import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { IconComponent } from '@shared/components/ui';
import { TippyModule } from '@ngneat/helipopper';
import { DefaultImageDirective } from '@shared/directives';
import { WorkShiftEntity } from '@core/entities';
import { isMobileView } from '@core/utils';
import { appSetting } from '@core/constants';
import { UseWorkShift } from '@core/usecases';
import { saveAs } from 'file-saver';

@Component({
  selector: 'app-work-shift-card',
  imports: [CommonModule, IconComponent, TranslateModule, TippyModule, DefaultImageDirective],
  templateUrl: './work-shift-card.component.html',
  styleUrls: ['./work-shift-card.component.scss'],
})
export class WorkShiftCardComponent {
  @Input() hideActions = false;
  @Input() shift: WorkShiftEntity;
  @Input() hideDeleteIcon = false;

  @Output() delete = new EventEmitter<WorkShiftEntity>();
  @Output() edit = new EventEmitter<WorkShiftEntity>();
  protected readonly isMobileView = isMobileView;

  private readonly _useWorkShift = new UseWorkShift();

  get isUploadADocument(): boolean {
    if (this.shift?.upload && this.shift.upload.length > 0) {
      const documentTypes = appSetting.documentTypes;
      const documentType = this.shift.upload[0].split('.').pop();
      return documentTypes.includes(documentType);
    }

    return false;
  }

  async downloadDocument() {
    if (this.shift?.upload && this.shift?.upload.length > 0) {
      try {
        const filePath = this.shift?.upload[0];
        const fileName = filePath.split('/').pop();

        const response = await this._useWorkShift.downloadShiftDocument(this.shift.id, filePath).toPromise();
        const blob = new Blob([response], { type: 'application/octet-stream' }); // Continue using a generic MIME type

        // Use FileSaver to save the file
        saveAs(blob, fileName || 'faq-document');
      } catch (error) {
        console.error('Error downloading the document:', error);
      }
    } else {
      console.error('FAQ document URL or title is missing.');
    }
  }
}
